<template>
    <bank-cards-find
        :params="{
            card: $route.params.card
        }"
        v-slot="{
            data: card,
            is_loading,
            has_loaded,
            error,
            find
        }"
        :find-on-created="true"
    >
        <div>
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <base-alert
                    v-if="!card.has_three_d_secure_support"
                    level="danger"
                    class="mb-6"
                >
                    <template slot="heading">Bank card does not support 3D Secure</template>

                    <template slot="content">
                        <p>
                            Unfortunately, this bank card does not support 3D Secure. To keep our customers safe from fraud, we do not
                            accept payments from cards that do not support the enhanced security of 3D Secure.
                        </p>
                    </template>
                </base-alert>

                <base-alert
                    v-else-if="!card.is_verified"
                    level="warning"
                    class="mb-6"
                >
                    <template slot="heading">Bank card requires confirmation</template>

                    <template slot="content">
                        <p class="mb-3">
                            You need to confirm this bank card before you can use it on Rentora.
                        </p>

                        <router-link
                            :to="{
                                name: $router.fix('dashboard.*.bank-cards.confirm.edit'),
                                params: {
                                    card: card.uuid
                                }
                            }"
                            class="btn btn-yellow btn-sm"
                        >
                            Confirm
                        </router-link>
                    </template>
                </base-alert>

                <details-card class="mb-6">
                    <template slot="header">
                        <div class="flex-grow mr-3 overflow-hidden">
                            <h1 class="text-lg font-normal truncate">
                                **** **** **** {{ card.last_four }}
                            </h1>
                        </div>

                        <div
                            v-if="is_loading"
                            class="w-6 h-6 mr-3"
                        >
                            <base-svg
                                name="icon-loading"
                                class="w-full h-full"
                            />
                        </div>
                    </template>
                    <template slot="body">
                        <grid-layout>
                            <grid-layout-item class="mb-3 md:w-1/3">
                                <div class="text-xs text-label">Brand</div>
                                <div class="text-sm uppercase">
                                    {{ card.brand }}
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mb-3 md:w-1/3">
                                <div class="text-xs text-label">Expiry</div>
                                <div class="text-sm">
                                    {{ card.exp }}
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mb-3 md:w-1/3">
                                <div class="text-xs text-label">Confirmed At</div>
                                <div class="text-sm">
                                    <template v-if="card.is_verified">
                                        {{ card.verified_at }}
                                    </template>
                                    <base-na v-else />
                                </div>
                            </grid-layout-item>
                        </grid-layout>
                    </template>
                </details-card>
            </template>
        </div>
    </bank-cards-find>
</template>

<script>
    import BankCardsFind from '../../../../components/bank-cards-find'
    import DetailsCard from '../../../../components/details-card'

    export default {
        components: {
            BankCardsFind,
            DetailsCard
        }
    }
</script>
